import { WizardStateMachineInterface } from '../../../../wizard/interfaces/wizard-state-machine';
import { WizardStepMeta } from '../../../../wizard/interfaces/wizard-step';
import { EditPipelineStepPaths } from '../interfaces/edit-pipeline-step-paths';
import { useStateMachine } from '../../../../wizard/hooks/useStateMachine';
import { EditPipelineSettings } from '../../components/EditPipelineSettings/EditPipelineSettings';
import { EditPipelineConfigureObjects } from '../../components/EditPipelineConfigureObjects/EditPipelineConfigureObjects';
import { EntityWizardEntitySubmit } from '../../../../shared/components/EntityWizardFooterComponents/EntityWizardFooterComponents';
import { EditPipelineReview } from '../../components/EditPipelineReview/EditPipelineReview';

export function useEditPipelineStateMachine(): WizardStateMachineInterface {
  const steps: WizardStepMeta[] = [
    {
      path: EditPipelineStepPaths.PIPELINE_SETTINGS,
      component: EditPipelineSettings,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => EditPipelineStepPaths.CONFIGURE_OBJECTS
    },
    {
      path: EditPipelineStepPaths.CONFIGURE_OBJECTS,
      component: EditPipelineConfigureObjects,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => EditPipelineStepPaths.REVIEW
    },
    {
      path: EditPipelineStepPaths.REVIEW,
      component: EditPipelineReview,
      footerComponent: EntityWizardEntitySubmit,
      getNextStep: () => undefined
    }
  ];

  const getInitialPath = () => {
    return EditPipelineStepPaths.PIPELINE_SETTINGS;
  };

  return useStateMachine({ steps, getInitialPath });
}
